import alertTemplate from './alert.html?raw';
import icons from '../../../assets/icons';

export class Alert extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.isClosable = false;
    }

    static get observedAttributes() {
        return [
            'alert-type',
            'alert-icon-alt',
            'alert-role',
            'closable',
            'close-button-aria-label',
        ];
    }

    connectedCallback() {
        this.isClosable =
            this.hasAttribute('closable') &&
            this.getAttribute('closable') !== 'false';
        this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;

        if (name === 'closable') {
            this.isClosable =
                this.hasAttribute('closable') &&
                this.getAttribute('closable') !== 'false';
        }

        this.render();
    }

    createHtmlTemplate() {
        const template = document.createElement('template');
        template.innerHTML = alertTemplate;
        this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    render() {
        this.clearPreviousRender();
        this.createHtmlTemplate();
        this.decorateElements();
        this.addEventListeners();
    }

    clearPreviousRender() {
        if (!this.shadowRoot) {
            this.attachShadow({ mode: 'open' });
        } else {
            this.shadowRoot.innerHTML = '';
        }
    }

    get alertType() {
        return this.getAttribute('alert-type') || 'information';
    }
    get alertIcon() {
        return icons[this.alertType];
    }
    get alertIconAlt() {
        return this.getAttribute('alert-icon-alt') || '';
    }
    get alertRole() {
        return this.getAttribute('alert-role') || 'status';
    }
    get closeButtonAriaLabel() {
        return this.getAttribute('close-button-aria-label') || 'Close';
    }
    get alertContainer() {
        return this.shadowRoot.querySelector('.alert-container');
    }
    get alertIconContainer() {
        return this.shadowRoot.querySelector('.alert-icon-container');
    }

    closeAlert() {
        this.dispatchEvent(
            new CustomEvent('close', { bubbles: false, composed: true })
        );
        this.remove();
    }

    decorateElements() {
        this.alertContainer.classList.add(this.alertType);
        this.alertIconContainer.innerHTML = this.alertIcon;

        if (this.isClosable) {
            this.createCloseButtonElements();
        }

        this.shadowRoot.appendChild(this.alertContainer);
    }

    createCloseButtonElements() {
        const closeButtonContainer = this.createCloseButtonContainer();
        const closeButton = this.createCloseButtonElement();

        closeButton.innerHTML = icons.close;
        closeButtonContainer.appendChild(closeButton);

        this.alertContainer.appendChild(closeButtonContainer);
    }

    createCloseButtonContainer() {
        const closeButtonContainer = document.createElement('div');
        closeButtonContainer.className = 'close-button-container';

        return closeButtonContainer;
    }

    createCloseButtonElement() {
        const closeButton = document.createElement('button');

        closeButton.type = 'button';
        closeButton.className = 'close-button';
        closeButton.ariaLabel = this.closeButtonAriaLabel;

        return closeButton;
    }

    addEventListeners() {
        if (this.isClosable) {
            const closeButton = this.shadowRoot.querySelector('.close-button');
            if (closeButton) {
                closeButton.addEventListener('click', () => this.closeAlert());
            }
        }
    }
}

customElements.define('svea-alert', Alert);
